<div id="driver-wizard" class="row ">
     <div class="d-flex justify-content-between align-items-center card-title" id="page-title">
          <h1 [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="11" [totalSteps]="11"></app-complete-bar>
                    <h2 [innerHtml]="'IDVerifyFailHeader' | translator: 'driver'">
                         ERROR VERIFYING YOUR IDENTITY
                    </h2>
                    
                    <div class="alert alert-danger"
                         [innerHtml]="'IDVerifyFailSummary' | translator: 'driver'">
                         We could not verify your identity with the information provided.
                    </div>
                    <p>
                         <span [innerHtml]="'CsInfoPart1' | translator: 'driver'">
                              Please contact the PSP Customer Support Team at <a class="alert-link"
                                 alt="call customer service"
                                 href="tel:8776429499"
                                 name="1-877-642-9499">1-877-642-9499</a>
                         </span>
                         <span [innerHtml]="'IDVerifyFailOptional' | translator: 'driver'">
                              &nbsp;for information on completing this transaction
                         </span>.
                         <span [innerHtml]="'CsInfoPart2' | translator: 'driver'">
                              The PSP team is available by phone Monday through Thursday from 8 AM to 6 PM ET, and on
                              Friday from 8 AM to 5
                              PM ET.
                         </span>
                    </p>

                    <app-contact-form [contactFormInfo]="contactFormInfo" class="form-wizard"></app-contact-form>

               </div>
          </div>
     </div>
     <app-progress-wizard 
          *ngIf="wizard"     
          [wizardObj]="wizard"
          [activeStep]="5"
          pageType="driver"
          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>